import {
    Button,
    FormControl,
    InputLabel,
    MenuItem,
    Select,
    Grid,
    Tooltip,
    Chip,
    Typography,
    Paper,
    TextField
} from "@mui/material"
import React, {useState, useEffect} from "react"
import AlertMessage from "src/components/alert-message"
import DatePickerSelect from "src/components/date/date-picker-select"
import DateTimePickerSelectDate from "src/components/date/date-time-picker-select-date"
import {DATE_FORMAT, DATE_FORMAT_ISO8601, DATE_TIME_FORMAT_SHOW} from "src/utils/constants"
import {IntegrationService} from "src/services/integration-service"
import dayjs from "dayjs"
import ProgressBar from "src/components/progress-bar"
import {formatDecimalCase} from "src/utils/format-decimal"
import RefreshRoundedIcon from '@mui/icons-material/RefreshRounded'
import SkeletonTable from "src/components/skeleton-table"
import {DataGrid} from "@mui/x-data-grid"
import {localeBRDataGridText} from "src/utils/data-grid-local-text"
import LoaderOverlay from "../../v2/components/LoaderOverlay/loader-overlay"
import Loader from "../../v2/components/Loader/loader"


const IntegrationWorkflowPage = () => {
    const [alertMessageState, setAlertMessageState] = React.useState({
        open: false,
        message: "",
        type: ""
    })

    const [dateSelected, setDateSelected] = useState(dayjs().subtract(7, 'day').set('hour', 19).set('minute', 15).set('second', 0).set('millisecond', 670))
    const [dateSelectedAiflow, setDateSelectedAirflow] = useState(dayjs().subtract(7, 'day').set('hour', 19).set('minute', 15).set('second', 0).set('millisecond', 670))
    const [dateSelectedDate, setDateSelectedDate] = useState(dayjs()) // default data atual
    const [dateSelectedDateFinal, setDateSelectedDateFinal] = useState(dayjs()) // default data atual
    const [dateSelectedFinal, setDateSelectedFinal] = useState(dayjs().set('hour', 19).set('minute', 15).set('second', 0).set('millisecond', 670))
    const [dateSelectedFinalAirflow, setDateSelectedFinalAirflow] = useState(dayjs().set('hour', 19).set('minute', 15).set('second', 0).set('millisecond', 670))
    const [loading, setLoading] = useState(false)
    const [name, setName] = useState(null)
    const [loadTable, setLoadTable] = useState(false)
    const [routineList, setRoutineList] = useState([])
    const [cetipValue, setCetipValue] = useState("")
    const integrationService = new IntegrationService()

    const alterarValor = (event) => {
        const selectedValue = event.target.value
        setName(selectedValue)
    }

    const closeAlert = () => {
        setAlertMessageState({...alertMessageState, open: false})
    }

    useEffect(() => {
        loadLastRoutines()
    }, [])

    const extractMetadata = (obj) => {
        const {metadata} = obj
        try {
            const valores = metadata.split(',')
            let data_referencia = valores.find(elemento => elemento.includes("data_referencia"))
            let qtde_dias = valores.find(elemento => elemento.includes("qtde_dias"))

            data_referencia !== undefined ? data_referencia = data_referencia.slice(-11).slice(0, -1) : null
            qtde_dias !== undefined ? qtde_dias = qtde_dias.slice(-3).slice(0, -1) : 0

            return {data_referencia: data_referencia, qtde_dias: qtde_dias}
        } catch (err) {
            return null
        }
    }

    const loadLastRoutines = () => {
        setLoadTable(true)

        integrationService.getRoutinesWorkflowInfo("DADOSEXTERNOS")
            .then((response) => {
                const {body} = response
                const {results} = body

                const rows = results.map((obj, index) => {
                    const metadata = extractMetadata(obj)

                    return {
                        ...obj,
                        id: index,
                        data_referencia: metadata === null ? null : metadata.data_referencia,
                        qtde_dias: metadata === null ? 90 : metadata.qtde_dias,
                    }
                })
                setRoutineList(rows)
                setLoadTable(false)
            })
            .catch((err) => {
                console.log(err)
                setLoadTable(false)
            })
    }


    const inicialRotina = () => {
        console.log(name)
        if (name === null) {
            openAlert('Escolha uma rotina', 'warning')
            return
        }
        setLoading(true)
        const indexadores = ["IPCA", "IGPM"]
        switch (name) {
            case 'B3AtivosRegWorkflow': {
                const date_ativos = dayjs(dateSelectedDate).format(DATE_FORMAT) // Formata a data para o formato desejado
                integrationService.startarRotinaB3AtivosRegWorkflow(date_ativos).then(() => {
                    setLoading(false)
                    openAlert('Processo iniciado com sucesso!', 'success')
                }).catch(() => {
                    setLoading(false)
                    openAlert('Erro no processo!', 'error')
                })
                break
            }
            case 'B3NegAnaliticoWorkflow': {
                const date_analitico = dayjs(dateSelectedDate).format(DATE_FORMAT) // Formata a data para o formato desejado
                integrationService.startarRotinaB3NegAnaliticoWorkflow(date_analitico).then(() => {
                    setLoading(false)
                    openAlert('Processo iniciado com sucesso!', 'success')
                }).catch(() => {
                    setLoading(false)
                    openAlert('Erro no processo!', 'error')
                })
                break
            }
            case 'B3AcoesNegAnaliticoWorkflow': {
                const date_acoes_analitico = dayjs(dateSelectedDate).format(DATE_FORMAT) // Formata a data para o formato desejado
                integrationService.startarRotinaB3AcoesNegAnaliticoWorkflow(date_acoes_analitico).then(() => {
                    setLoading(false)
                    openAlert('Processo iniciado com sucesso!', 'success')
                }).catch(() => {
                    setLoading(false)
                    openAlert('Erro no processo!', 'error')
                })
                break
            }
            case 'B3AcoesNegRegistradosWorkflow': {
                const date_acoes_registrados = dayjs(dateSelectedDate).format(DATE_FORMAT) // Formata a data para o formato desejado
                integrationService.startarRotinaB3AcoesNegRegistradosWorkflow(date_acoes_registrados).then(() => {
                    setLoading(false)
                    openAlert('Processo iniciado com sucesso!', 'success')
                }).catch(() => {
                    setLoading(false)
                    openAlert('Erro no processo!', 'error')
                })
                break
            }
            case 'B3FundosNetWorkflow': {
                const date_fundos_net = dayjs(dateSelectedDate).format(DATE_FORMAT) // Formata a data para o formato desejado
                integrationService.startarRotinaB3FundosNetWorkflow(date_fundos_net).then(() => {
                    setLoading(false)
                    openAlert('Processo iniciado com sucesso!', 'success')
                }).catch(() => {
                    setLoading(false)
                    openAlert('Erro no processo!', 'error')
                })
                break
            }
            case 'B3NegConsolidadoWorkflow': {
                const date_consolidado = dayjs(dateSelectedDate).format(DATE_FORMAT) // Formata a data para o formato desejado
                integrationService.startarRotinaB3NegConsolidadoWorkflow(date_consolidado).then(() => {
                    setLoading(false)
                    openAlert('Processo iniciado com sucesso!', 'success')
                }).catch(() => {
                    setLoading(false)
                    openAlert('Erro no processo!', 'error')
                })
                break
            }
            case 'BacenCadastro': {
                const formattedDate = dateSelectedDate.format(DATE_FORMAT)
                integrationService.startarBacenCadastro(formattedDate).then(() => {
                    setLoading(false)
                    openAlert('Processo iniciado com sucesso!', 'success')
                }).catch(() => {
                    setLoading(false)
                    openAlert('Erro no processo!', 'error')
                })
                break
            }
            case 'BroadcastCotacoesAcoesB3Workflow': {
                const dataReferenciaWorkflow = dayjs(dateSelectedDate).format(DATE_FORMAT) // Formata a data para o formato desejado
                integrationService.startarRotinaBroadcastCotacoesAcoesB3Workflow(dataReferenciaWorkflow).then(() => {
                    setLoading(false)
                    openAlert('Processo iniciado com sucesso!', 'success')
                }).catch(() => {
                    setLoading(false)
                    openAlert('Erro no processo!', 'error')
                })
                break
            }
            case 'CBondsWorkflow': {
                const dataCBondsFormat = dayjs(dateSelectedDate).format(DATE_FORMAT)
                integrationService.startarRotinaCBondsWorkflow(dataCBondsFormat).then(() => {
                    setLoading(false)
                    openAlert('Processo iniciado com sucesso!', 'success')
                }).catch(() => {
                    setLoading(false)
                    openAlert('Erro no processo!', 'error')
                })
                break
            }
            case 'CVMFatosRelevantes':
                integrationService.startarCVMFatosRelevantes(dateSelectedDate).then(() => {
                    setLoading(false)
                    openAlert('Processo iniciado com sucesso!', 'success')
                }).catch(() => {
                    setLoading(false)
                    openAlert('Erro no processo!', 'error')
                })
                break
            case 'CVMFatosRelevantesV2':
                integrationService.startarCVMFatosRelevantesV2(dateSelectedDate).then(() => {
                    openAlert('Processo iniciado com sucesso!', 'success')
                })
                    .catch(() => {
                        openAlert('Erro no processo!', 'error')
                    })
                    .finally(() => {
                        setLoading(false)
                    })
                break
            case 'EstoqueRegistradoWorkflow': {
                const date_estoque = dayjs(dateSelectedDate).format(DATE_FORMAT) // Formata a data para o formato desejado
                integrationService.startarRotinaEstoqueRegistradoWorkflow(date_estoque).then(() => {
                    setLoading(false)
                    openAlert('Processo iniciado com sucesso!', 'success')
                }).catch(() => {
                    setLoading(false)
                    openAlert('Erro no processo!', 'error')
                })
                break
            }
            case 'MarketData':
                integrationService.startarRotinaMarkeData(dateSelected, dateSelectedFinal).then(() => {
                    setLoading(false)
                    openAlert('Processo iniciado', 'success')
                }).catch(() => {
                    setLoading(false)
                    openAlert('Erro no processo!', 'error')
                })
                break
            case 'MarketData_airflow':
                integrationService.startarRotinaMarkeDataAirflow(dateSelectedAiflow, dateSelectedFinalAirflow).then(() => {
                    setLoading(false)
                    openAlert('Processo iniciado', 'success')
                }).catch(() => {
                    setLoading(false)
                    openAlert('Erro no processo!', 'error')
                })
                break
            case 'FincsMarketdataCetips':
                integrationService.startarRotinaFincsMarketDataCetips(cetipValue, dateSelectedAiflow, dateSelectedFinalAirflow).then(() => {
                    setLoading(false)
                    openAlert('Processo iniciado', 'success')
                }).catch(() => {
                    setLoading(false)
                    openAlert('Erro no processo!', 'error')
                })
                break
            case 'MarketData_full_airflow':
                integrationService.startarRotinaFullMarkeDataAirflow().then(() => {
                    setLoading(false)
                    openAlert('Processo iniciado', 'success')
                }).catch(() => {
                    setLoading(false)
                    openAlert('Erro no processo!', 'error')
                })
                break
            case 'SerieHistórica': {
                const formattedDataInicio = dayjs(dateSelectedDate).format(DATE_FORMAT)
                const formattedDataFim = dayjs(dateSelectedDateFinal).format(DATE_FORMAT)

                integrationService.startarRotinaSerieHistoricaAirflow(formattedDataInicio, formattedDataFim)
                    .then(() => {
                        setLoading(false)
                        openAlert('Processo iniciado', 'success')
                    })
                    .catch(() => {
                        setLoading(false)
                        openAlert('Erro no processo!', 'error')
                    })
                break
            }
            case 'PreviaInflacao':
                integrationService.startarRotinaPreviaInflacao(indexadores, dateSelectedDate).then(() => {
                    setLoading(false)
                    openAlert('Processo iniciado com sucesso!', 'success')
                }).catch(() => {
                    setLoading(false)
                    openAlert('Erro no processo!', 'error')
                })
                break
            case 'PreviaInflacaoAnbima':
                integrationService.startarPreviaInflacaoAnbima(dateSelectedDate).then(() => {
                    setLoading(false)
                    openAlert('Processo iniciado com sucesso!', 'success')
                }).catch(() => {
                    setLoading(false)
                    openAlert('Erro no processo!', 'error')
                })
                break
            case 'PreviaInflacaoWorkflow': {
                const formattedDate = dayjs(dateSelectedDate).format(DATE_FORMAT)
                integrationService.startarPreviaInflacaoWorkflow(formattedDate)
                    .then(() => {
                        setLoading(false)
                        openAlert('Processo iniciado com sucesso!', 'success')
                    })
                    .catch(() => {
                        setLoading(false)
                        openAlert('Erro no processo!', 'error')
                    })
                break
            }
            case 'TaxasRecebiveisMercado':
                integrationService.startarTaxasRecebiveisMercado(dateSelectedDate).then(() => {
                    setLoading(false)
                    openAlert('Processo iniciado com sucesso!', 'success')
                }).catch(() => {
                    setLoading(false)
                    openAlert('Erro no processo!', 'error')
                })
                break

            case 'BacenCadastroWorkflow': {
                // Garante que a data é um objeto dayjs
                const formattedDate = dayjs(dateSelectedDate).format(DATE_FORMAT) // Formata a data para o formato desejado

                integrationService.startarBacenCadastroWorkflow(formattedDate)
                    .then(() => {
                        setLoading(false)
                        openAlert('Processo iniciado com sucesso!', 'success')
                    })
                    .catch(() => {
                        setLoading(false)
                        openAlert('Erro no processo!', 'error')
                    })
                break
            }
            case 'CVMFatosRelevantesWorkflow': {
                const formattedDatecvm = dayjs(dateSelectedDate).format(DATE_FORMAT) // Formata a data para o formato desejado
                integrationService.startarCVMFatosRelevantesWorkflow(formattedDatecvm).then(() => {
                    setLoading(false)
                    openAlert('Processo iniciado com sucesso!', 'success')
                }).catch(() => {
                    setLoading(false)
                    openAlert('Erro no processo!', 'error')
                })
                break
            }
            case 'CVMFatosRelevantesV2Workflow': {
                const formattedDatecvm = dayjs(dateSelectedDate).format(DATE_FORMAT)
                integrationService.startarCVMFatosRelevantesV2Workflow(formattedDatecvm).then(() => {
                    openAlert('Processo iniciado com sucesso!', 'success')
                })
                    .catch(() => {
                        openAlert('Erro no processo!', 'error')
                    })
                    .finally(() => {
                        setLoading(false)
                    })
                break
            }
            case 'CVMBalancosWorkflow': {
                const formattedDatecvm = dayjs(dateSelectedDate).format(DATE_FORMAT) // Formata a data para o formato desejado
                integrationService.startarCVMFatosRelevantesV2Workflow(formattedDatecvm).then(() => {
                    openAlert('Processo iniciado com sucesso!', 'success')
                })
                .catch(() => {
                    openAlert('Erro no processo!', 'error')
                })
                .finally(() => {
                    setLoading(false)
                })
                break
            }
            case 'ColetaDeTaxasERiskFreeWorkflow': {
                const formattedDatecvm = dayjs(dateSelectedDate).format(DATE_FORMAT) // Formata a data para o formato desejado
                integrationService.startarColetaDeTaxasERiskFreeWorkflow(formattedDatecvm).then(() => {
                    setLoading(false)
                    openAlert('Processo iniciado com sucesso!', 'success')
                }).catch(() => {
                    setLoading(false)
                    openAlert('Erro no processo!', 'error')
                })
                break
            }
            case 'CVMCadastroWorkflow':
                integrationService.startarCvmCadastroWorkflow().then(() => {
                    setLoading(false)
                    openAlert('Processo iniciado com sucesso!', 'success')
                }).catch(() => {
                    setLoading(false)
                    openAlert('Erro no processo!', 'error')
                })
                break
            case 'AlimentaChatbotWorkflow': {
                const dataReferenciaWorkflow = dayjs(dateSelectedDate).format(DATE_FORMAT) // Formata a data para o formato desejado
                integrationService.iniciaRotinaAlimentacaoChatBotWorkflow(dataReferenciaWorkflow).then(() => {
                    setLoading(false)
                    openAlert('Processo iniciado com sucesso!', 'success')
                }).catch(() => {
                    setLoading(false)
                    openAlert('Erro no processo!', 'error')
                })
                break
            }
        }

    }

    const onChangeDatePickerDate = (value) => {
        setDateSelected(value)
    }

    const onChangeDatePickerDateFinal = (value) => {
        setDateSelectedFinal(value)
    }

    const onChangeDatePickerDateTime = (value) => {
        const formattedDate = value.format(DATE_FORMAT)
        setDateSelectedDate(formattedDate)
    }

    const onChangeDatePickerDateTimeFinal = (value) => {
        const formattedDateFinal = value.format(DATE_FORMAT)
        setDateSelectedDateFinal(formattedDateFinal)
    }

    const onChangeDatePickerDate_airflow = (value) => {
        setDateSelectedAirflow(value)
    }

    const onChangeDatePickerDateFinal_aiflow = (value) => {
        setDateSelectedFinalAirflow(value)

        const dateInicial = dayjs(value).subtract(7, 'day')
        setDateSelectedAirflow(dateInicial)

        console.log("Data Inicial (7 dias antes):", dateInicial.format(DATE_FORMAT_ISO8601))
    }

    const openAlert = (message, type) => {
        setAlertMessageState({
            ...alertMessageState,
            open: true,
            message: message,
            type: type
        })
    }

    const verifyTableStatus = (params) => {
        const {value, row} = params
        const {text, color} = integrationService.verifyTableStatusWorkflow(value)
        const {total_registros, total_registros_processados} = row

        return <Tooltip title={`processados ${total_registros_processados} de ${total_registros}`}>
            <Chip label={text} variant="contained" color={color}/>
        </Tooltip>
    }

    const progressBar = (params) => {
        const {row, value} = params
        const {total_registros} = row
        const valueBar = (value / total_registros) * 100
        let formatedValue = formatDecimalCase(valueBar)

        if (value < 0.1) {
            formatedValue = 0
        }
        console.log(formatedValue)
        return <ProgressBar value={Number(formatedValue)}/>
    }

    const formatDateUtc = (params, format) => {
        const {value} = params

        if (params.value === null) return "N/A"

        return dayjs(value).utc().format(format)
    }

    const columns = [
        {
            field: 'rotina',
            headerName: 'Rotina',
            minWidth: 250,
        },

        {
            field: 'rotina_grupo',
            headerName: 'Grupo',
            minWidth: 250,
        },
        {
            field: 'status',
            headerName: 'Status',
            minWidth: 200,
            renderCell: verifyTableStatus
        },
        {
            field: 'total_registros',
            headerName: 'Total de Registros',
            flex: 1,
            minWidth: 150,

        },
        {
            field: '"total_registros_processados',
            headerName: 'Progresso',
            minWidth: 150,
            renderCell: (params) => progressBar(params)

        },
        {
            field: 'nome_usuario',
            headerName: 'Usuário',
            minWidth: 150,
        },
        {
            field: 'criado_em',
            headerName: 'Data de Criação',
            flex: true,
            minWidth: 200,
            type: 'date',
            valueFormatter: params => formatDateUtc(params, DATE_TIME_FORMAT_SHOW),
        },
        {
            field: 'atualizado_em',
            headerName: 'Data de Atualização',
            flex: true,
            minWidth: 200,
            type: 'date',
            valueFormatter: params => formatDateUtc(params, DATE_TIME_FORMAT_SHOW),
        },
    ]


    return (
        <div>
            {
                loading && (
                    <LoaderOverlay>
                        <Loader/>
                    </LoaderOverlay>
                )
            }

            <AlertMessage open={alertMessageState.open} message={alertMessageState.message}
                          type={alertMessageState.type} close={closeAlert}/>

            <Grid container alignItems="flex-start" justifyContent="flex-start" spacing={3}>
                <Grid item sm={12} md={6} xl={4} xs={12}>
                    <Typography variant={"h5"}>
                        Importação manual das rotinas
                    </Typography>
                </Grid>
            </Grid>
            <br/>

            <Grid container alignItems="flex-start" justifyContent="flex-start" spacing={3}>
                <Grid item xs={12} md={3} xl={4}>
                    <FormControl fullWidth variant={"standard"}>
                        <InputLabel id="demo-simple-select-label">Selecione uma rotina</InputLabel>
                        <Select
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            value={name}
                            label="Rotinas"
                            onChange={alterarValor}
                        >
                            <MenuItem value="B3AcoesNegAnaliticoWorkflow">B3AcoesNegAnaliticoWorkflow</MenuItem>
                            <MenuItem value="B3AcoesNegRegistradosWorkflow">B3AcoesNegRegistradosWorkflow</MenuItem>
                            <MenuItem value="B3AtivosRegWorkflow">B3AtivosRegWorkflow</MenuItem>
                            <MenuItem value="B3NegAnaliticoWorkflow">B3NegAnaliticoWorkflow</MenuItem>
                            <MenuItem value="B3NegConsolidadoWorkflow">B3NegConsolidadoWorkflow</MenuItem>
                            <MenuItem value="B3FundosNetWorkflow">B3FundosNetWorkflow</MenuItem>
                            <MenuItem value="BacenCadastroWorkflow">BacenCadastroWorkflow</MenuItem>
                            <MenuItem value="BroadcastCotacoesAcoesB3Workflow">BroadcastCotacoesAcoesB3Workflow</MenuItem>
                            <MenuItem value="CBondsWorkflow">CBondsWorkflow</MenuItem>
                            <MenuItem value="CVMBalancosWorkflow">CVMBalancosWorkflow</MenuItem>
                            <MenuItem value="CVMCadastroWorkflow">CVMCadastroWorkflow</MenuItem>
                            <MenuItem value="CVMFatosRelevantesWorkflow">CVMFatosRelevantesWorkflow</MenuItem>
                            <MenuItem value="CVMFatosRelevantesV2Workflow">CVMFatosRelevantesV2Workflow</MenuItem>
                            <MenuItem
                                value="ColetaDeTaxasERiskFreeWorkflow">ColetaDeTaxasERiskFreeWorkflow</MenuItem>
                            <MenuItem value="EstoqueRegistradoWorkflow">EstoqueRegistradoWorkflow</MenuItem>
                            <MenuItem value="FincsMarketdataCetips">Fincs Marketdata Cetips</MenuItem>
                            <MenuItem value="MarketData_airflow">MarketData_airflow</MenuItem>
                            <MenuItem value="MarketData_full_airflow">MarketData full airflow</MenuItem>
                            <MenuItem value="PreviaInflacaoWorkflow">PreviaInflacaoWorkflow</MenuItem>
                            <MenuItem value="SerieHistórica">Serie Histórica</MenuItem>
                            <MenuItem value="AlimentaChatbotWorkflow">AlimentaChatbotWorkflow</MenuItem>
                            {/* <MenuItem value="RiskFreeWorkflow">RiskFreeWorkflow</MenuItem> */}
                        </Select>
                    </FormControl>
                </Grid>
            </Grid>
            <br />

            {name === 'MarketData' && (
                <Grid container alignItems="flex-start" justifyContent="flex-start" spacing={2}>
                    <Grid item sm={12} md={"auto"} xl={4} xs={12}>
                        <DateTimePickerSelectDate
                            label="Data de Exibição"
                            onChange={onChangeDatePickerDate}
                            value={dateSelected}
                        />
                    </Grid>
                    <Grid item sm={12} md={"auto"} xl={4} xs={12}>
                        <DateTimePickerSelectDate
                            label="Data de Exibição Final"
                            onChange={onChangeDatePickerDateFinal}
                            value={dateSelectedFinal}
                        />
                    </Grid>
                </Grid>
            )}
            
            {name === 'BroadcastCotacoesAcoesB3Workflow' && (
                <Grid container alignItems="flex-start" justifyContent="flex-start" spacing={3}>
                    <Grid item sm={12} md={6} xl={4} xs={12}>
                        <DatePickerSelect
                            label="Data de Referência"
                            onChange={onChangeDatePickerDateTime}
                            value={dateSelectedDate}
                        />
                    </Grid>
                </Grid>
            )}

            {name === 'MarketData_airflow' && (
                <Grid container alignItems="flex-start" justifyContent="flex-start" spacing={2}>
                    <Grid item sm={12} md={"auto"} xl={4} xs={12}>
                        <DateTimePickerSelectDate
                            label="Data de Exibição"
                            onChange={onChangeDatePickerDate_airflow}
                            value={dateSelectedDate}
                        />
                    </Grid>
                    <Grid item sm={12} md={"auto"} xl={4} xs={12}>
                        <DateTimePickerSelectDate
                            label="Data de Exibição Final"
                            onChange={onChangeDatePickerDateFinal_aiflow}
                            value={dateSelectedDateFinal}
                        />
                    </Grid>
                </Grid>
            )}

            {name === 'FincsMarketdataCetips' && (
                <Grid container alignItems="flex-start" justifyContent="flex-start" spacing={2}>
                    <Grid item sm={12} md={"auto"} xl={4} xs={12}>
                        <DateTimePickerSelectDate
                            label="Data de Exibição"
                            onChange={onChangeDatePickerDate_airflow}
                            value={dateSelectedDate}
                        />
                    </Grid>

                    <Grid item sm={12} md={"auto"} xl={4} xs={12}>
                        <DateTimePickerSelectDate
                            label="Data de Exibição Final"
                            onChange={onChangeDatePickerDateFinal_aiflow}
                            value={dateSelectedDateFinal}
                        />
                    </Grid>

                    <Grid item sm={12} md={3} xl={4} xs={12}>
                        <TextField
                            label="Cetips (separados por vírgula)"
                            variant="outlined"
                            fullWidth
                            value={cetipValue}
                            onChange={(e) => setCetipValue(e.target.value)}
                        />
                    </Grid>
                </Grid>
            )}

            {name === 'SerieHistórica' && (
                <Grid container alignItems="flex-start" justifyContent="flex-start" spacing={2}>
                    <Grid item sm={12} md={"auto"} xl={4} xs={12}>
                        <DatePickerSelect
                            label="Data de Exibição"
                            onChange={onChangeDatePickerDateTime}
                            value={dateSelectedAiflow}
                        />
                    </Grid>
                    <Grid item sm={12} md={"auto"} xl={4} xs={12}>
                        <DatePickerSelect 
                            label="Data de Exibição Final"
                            onChange={onChangeDatePickerDateTimeFinal}
                            value={dateSelectedFinalAirflow}
                        />
                    </Grid>
                </Grid>
            )}

            {(name === 'CBondsWorkflow' || name === 'B3NegConsolidadoWorkflow' || name === 'B3AtivosRegWorkflow' || name === 'EstoqueRegistradoWorkflow' || name === 'B3NegAnaliticoWorkflow' || name === 'B3AcoesNegAnaliticoWorkflow' || name === 'B3AcoesNegRegistradosWorkflow' || name === 'B3FundosNetWorkflow' || name === 'CVMFatosRelevantesWorkflow' || name === 'CVMFatosRelevantesV2Workflow' || name === 'PreviaInflacaoWorkflow' || name === 'ColetaDeTaxasERiskFreeWorkflow' || name === 'BacenCadastroWorkflow' || name === 'CVMBalancosWorkflow') && (
                <Grid container alignItems="flex-start" justifyContent="flex-start" spacing={3}>
                    <Grid item sm={12} md={6} xl={4} xs={12}>
                        <DatePickerSelect
                            label="Data de Exibição"
                            onChange={onChangeDatePickerDateTime}
                            value={dateSelectedDate}
                        />
                    </Grid>
                </Grid>
            )}

            <br/>
            <Grid container alignItems="flex-start" justifyContent="flex-start" spacing={3}>
                <Grid item sm={12} md={6} xl={4} xs={12}>
                    <Button variant="contained" onClick={inicialRotina}>Iniciar Rotina</Button>
                </Grid>
            </Grid>

            <br/>
            <Grid container direction="row" justifyContent="space-between" spacing={2}>
                <Grid item>
                    <Typography variant={"h5"}>Últimas Rotinas</Typography>
                </Grid>
                <Grid item>
                    <Button variant="outlined" onClick={() => loadLastRoutines()}>
                        <RefreshRoundedIcon/></Button>
                </Grid>
            </Grid>
            <br/>
            <Grid container direction="row" justifyContent="left" spacing={2}>
                <Grid item xl={12} md={12} xs={12}>
                    {loadTable ? <SkeletonTable/> :
                        <Paper>
                            <DataGrid
                                autoHeight
                                getRowHeight={() => 45}
                                rows={routineList}
                                columns={columns}
                                initialState={{
                                    pagination: {
                                        paginationModel: {
                                            pageSize: 10,
                                        },
                                    },
                                }}
                                pageSizeOptions={[10, 25, 50, 100]}
                                disableRowSelectionOnClick
                                sortingOrder={['asc', 'desc']}
                                localeText={localeBRDataGridText}
                            />
                        </Paper>}
                </Grid>
            </Grid>

        </div>
    )
}
export default IntegrationWorkflowPage
